import mapboxgl from 'mapbox-gl';
import regions from "../regions.json";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

export class MapController {
    constructor() {
        this.centersMarker      = [];
        this.orthoptistesMarker = [];
        this.buildMap();
    }

    buildMap() {
        // Init map
        mapboxgl.accessToken = window.mapboxToken;
         this.map = new mapboxgl.Map({
            container: 'mapbox-orthoptiste',
            style: "mapbox://styles/mapbox/light-v10",
            center: [2.85, 46.93], // starting position [lng, lat]
            zoom: 4.8 // starting zoom
        });

        this.map.on("load", () => {
            this.map.setLayoutProperty("country-label", "text-field", ["get", "name_fr"]);
        });

        this.geocoder = new MapboxGeocoder({
            accessToken: window.mapboxToken,
            mapboxgl: this.map,
            placeholder: "Rechercher une ville, un centre",
            countries: "FR",
            flyTo: {
                easing: function(t) {
                    return t;
                },
                maxZoom: 10,
            },
            marker: false
        });

        document.getElementById('geocoder-container').appendChild(this.geocoder.onAdd(this.map));

        this.handleShowallCta();
        this.handleOnlyCenters();
        this.handleSelectRegion();
        this.handleSelectReason();

        this.addCenterMarker().then( () => {
            this.selectItem(this.centersMarker);
        });
        this.addOrthoptisteMarker().then( () => {
            this.selectItem(this.orthoptistesMarker);
            this.handleSearchItem();
            this.handleparamsUrl();
        });
    }

    addCenterMarker() {
        let url = "/wp-json/wp/v2/centers/";

        return fetch(url)
            .then((res) => res.json())
            .then( (data)=> {
                if (data.length !== 0) {
                    this.centersMarker = Array.from(data.items).map( center => {
                        let marker = new mapboxgl.Marker({
                            color: '#F6C3AE'
                        })
                        .setLngLat([center.map_lng, center.map_lat])
                        .setPopup(
                            new mapboxgl.Popup({ offset: 25 }) // add popups
                                .setHTML(`
                                    <div class="popup-content">
                                        <div class="content-info">
                                            <p class="title">${center.name}</p>
                                            ${center.address || center.postcode || center.city ? `
                                            <p>${center.address ? `${center.address} ` : ""} ${
                                            center.postcode ? `${center.postcode} ` : ""
                                            } ${center.city ? `${center.city} ` : ""}</p>`
                                            : ""}
                                            ${center.phone ? `<p>${center.phone}</p>` : ""}
                                        </div>
                                        <div>
                                            <a href="${center.link}"
                                               target="_blank"
                                               title="Prendre rendez-vous">Prendre rendez-vous</a>
                                        </div>
                                    </div>
                                `)
                        );
                        let el = marker.getElement();
                        el.setAttribute('data-id', center.id);
                        return marker.addTo(this.map);
                    });
                }
            });
    }

    addOrthoptisteMarker() {
        let url = "/wp-json/wp/v2/orthoptistes/";

        return fetch(url)
            .then((res) => res.json())
            .then( (data) => {
                if (data.length !== 0) {
                     this.orthoptistesMarker = Array.from(data.items).map( orthoptiste => {
                        let marker = new mapboxgl.Marker({
                            color: '#467CA0'
                        })
                        .setLngLat([orthoptiste.long, orthoptiste.lat])
                        .setPopup(
                            new mapboxgl.Popup({ offset: 25 }) // add popups
                                .setHTML(`
                                    <div class="popup-content">
                                        <div class="content-info">
                                            <p class="title">${orthoptiste.last_name} ${orthoptiste.first_name}</p>
                                            ${orthoptiste.address || orthoptiste.city ? `
                                                <p>${orthoptiste.address ? `${orthoptiste.address} ` : ""}
                                                   ${orthoptiste.city ? `${orthoptiste.city} ` : ""}</p>`
                                            : ""}
                                            ${orthoptiste.phone ? `<p>${orthoptiste.phone}</p>` : ""}
                                        </div>
                                        <div>
                                            <a href="${orthoptiste.ortho_link}"
                                               target="_blank"
                                               class="cta-orthoptiste"
                                               title="Prendre rendez-vous">Prendre rendez-vous</a>
                                        </div>
                                    </div>
                                `)
                        );
                         let el = marker.getElement();
                         el.setAttribute('data-id', orthoptiste.id);
                         return marker.addTo(this.map);
                    });
                }
            });
    }

    selectItem(mapItems) {
        const itemContainer = document.querySelector('#listings');
        if ( itemContainer ) {
            let items = itemContainer.querySelectorAll('.items');
            if ( items ) {
                Array.from(items).forEach( item => {
                    item.addEventListener('click', () => {
                        let itemId = item.getAttribute('data-id');
                        for ( const mapItem of mapItems ) {
                            let el        = mapItem.getElement();
                            let mapItemId = el.getAttribute('data-id');
                            if ( itemId === mapItemId ) {
                                let lngLat = mapItem.getLngLat();
                                this.map.flyTo({
                                   center: [lngLat.lng, lngLat.lat],
                                   zoom: 15
                                });
                                mapItem.togglePopup();
                                el.classList.add('marker-selected');
                                this.handleClosePopup();
                            }
                        }
                    });
                });
            }
        }
    }

    handleShowallCta() {
        const showAllButton = document.querySelector('#show-all');
        const itemContainer = document.querySelector('#listings');
        const noResults = itemContainer.querySelector('.no-results');
        if ( showAllButton ) {
            showAllButton.addEventListener('click', () => {
                this.geolng = null;
                this.geolat = null;
                this.map.flyTo({
                    center: [2.85, 46.93],
                    zoom: 4.8
                });
                this.orthoptistesMarker.map( marker => {
                    let el        = marker.getElement();
                    let mapItemId = el.getAttribute('data-id');
                    let items = itemContainer.querySelectorAll('.items');
                    if ( items ) {
                        Array.from(items).forEach( item => {
                            let itemId = item.getAttribute('data-id');
                            if ( mapItemId === itemId ) {
                                item.style.display = 'flex';
                                marker.addTo(this.map);
                            }
                        });
                    }
                });
                this.centersMarker.map( marker => {
                    let el        = marker.getElement();
                    let mapItemId = el.getAttribute('data-id');
                    let items = itemContainer.querySelectorAll('.items');
                    if ( items ) {
                        Array.from(items).forEach( item => {
                            let itemId = item.getAttribute('data-id');
                            if ( mapItemId === itemId ) {
                                item.style.display = 'flex';
                                marker.addTo(this.map);
                            }
                        });
                    }
                });
                if ( noResults.classList.contains('show') ) {
                    noResults.classList.remove('show');
                }
                let indexes     = document.querySelectorAll("[data-name]");
                let arrItems    = Array.from(indexes);
                let sortedItems = arrItems.sort(this.compareName);
                sortedItems.forEach( item => itemContainer.appendChild(item));
            });
        }
    }

    handleOnlyCenters() {
        const onlyCentersButton = document.querySelector('#show-only-centers');
        const itemContainer     = document.querySelector('#listings');
        const noResults         = itemContainer.querySelector('.no-results');
        if ( onlyCentersButton ) {
            onlyCentersButton.addEventListener( 'click', () => {
                this.orthoptistesMarker.map( marker => {
                    let el        = marker.getElement();
                    let mapItemId = el.getAttribute('data-id');
                    let items = itemContainer.querySelectorAll('.items');
                    if ( items ) {
                        Array.from(items).forEach( item => {
                            let itemId = item.getAttribute('data-id');
                            if ( mapItemId === itemId ) {
                                item.style.display = 'none';
                                marker.remove();
                            }
                        });
                    }
                });
                this.centersMarker.map( marker => {
                    let el        = marker.getElement();
                    let mapItemId = el.getAttribute('data-id');
                    let items = itemContainer.querySelectorAll('.items');
                    if ( items ) {
                        Array.from(items).forEach( item => {
                            let itemId = item.getAttribute('data-id');
                            if ( mapItemId === itemId ) {
                                item.style.display = 'flex';
                                marker.addTo(this.map);
                            }
                        });
                    }
                });
                if ( noResults.classList.contains('show') ) {
                    noResults.classList.remove('show');
                }
            });
        }
    }

    handleSelectRegion() {
        const selectRegions = document.querySelector('#filter-region');
        const itemContainer = document.querySelector('#listings');
        if ( selectRegions ) {
            Array.from(regions).forEach( region => {
                let opt = document.createElement('option');
                opt.value = region.value;
                opt.innerHTML = region.label;
                selectRegions.appendChild(opt);
            });

            selectRegions.addEventListener( 'change', (e) => {
                this.getSelectedRegion(e.target.value);
                let indexes     = document.querySelectorAll("[data-name]");
                let arrItems    = Array.from(indexes);
                let sortedItems = arrItems.sort(this.compareName);
                sortedItems.forEach( item => itemContainer.appendChild(item));
            });
        }
    }

    handleSelectReason() {
        const selectReasons = document.querySelector('#filter-reason');
        const itemContainer = document.querySelector('#listings');
        if ( selectReasons ) {
            selectReasons.addEventListener( 'change', (e) => {
                this.getSelectedReason(e.target.value);
                let indexes     = document.querySelectorAll("[data-name]");
                let arrItems    = Array.from(indexes);
                let sortedItems = arrItems.sort(this.compareName);
                sortedItems.forEach( item => itemContainer.appendChild(item));
            });
        }

    }

    getSelectedRegion (selectedRegion) {
        const selectReasons = document.querySelector('#filter-reason');
        if (selectedRegion === 'none') {
            this.fetchItem(selectReasons.value, selectedRegion);
        }

        Array.from(regions).forEach( region => {
            if (selectedRegion === 'none') {
                return this.map.fitBounds([
                    [10, 51.5],
                    [-5.8, 41],
                ]);
            }
            else {
                if ( region.value === selectedRegion ) {
                    this.geolng = region.long;
                    this.geolat = region.lat;
                    this.fetchItem( selectReasons.value, region.value );
                    return this.map.fitBounds([
                        [region.east, region.north],
                        [region.west, region.south],
                    ]);
                }
            }
        });
    }

    getSelectedReason (selectedReason) {
        this.fetchItem( selectedReason );
        if ( selectedReason === 'all' ||
             selectedReason === 'Téléconsultation' ||
             selectedReason === 'Consultation Ophtalmologique' ) {
            this.orthoptistesMarker.map( marker => {
                marker.addTo(this.map);
            });
        }
    }

    handleClosePopup() {
        let closePopup = document.querySelectorAll('.mapboxgl-popup-close-button');
        if ( closePopup ) {
            Array.from(closePopup).forEach( item => {
               item.addEventListener('click', (e) => {
                   let markerSelected = document.querySelector('.mapboxgl-marker.mapboxgl-marker-anchor-center.marker-selected');
                   if ( markerSelected ) {
                       markerSelected.classList.remove('marker-selected');
                   }
               });
            });
        }
    }

    handleSearchItem() {
        let reason;
        const queryString = window.location.search;
        if ( queryString ) {
            const urlParams = new URLSearchParams(queryString);
            reason = urlParams.get('reason');
            if ( reason === 'Consultation Ophtalmologique' || reason === 'Téléconsultation' ) {
                reason = null;
            }
            else {
                const itemContainer = document.querySelector('#listings');
                this.orthoptistesMarker.map( marker => {
                    let el        = marker.getElement();
                    let mapItemId = el.getAttribute('data-id');
                    let items = itemContainer.querySelectorAll('.items');
                    if ( items ) {
                        Array.from(items).forEach( item => {
                            let itemId = item.getAttribute('data-id');
                            if ( mapItemId === itemId ) {
                                item.style.display = 'none';
                                marker.remove();
                            }
                        });
                    }
                });
            }
        }
        this.geocoder.on('result', ({result}) => {
            this.geolng = result.center[0];
            this.geolat = result.center[1];
            this.fetchItem( reason );
        })
    }

    handleparamsUrl() {
        const queryString = window.location.search;
        if ( queryString ) {
            const urlParams = new URLSearchParams(queryString);
            const search = urlParams.get('search');
            const txtSearch = document.getElementsByClassName("mapboxgl-ctrl-geocoder--input");
            if ( txtSearch ) {
                txtSearch[0].value = search;
                this.geocoder.query(search);
            }
        }
    }

    compareDistance(a, b) {
        if ( parseFloat(a.dataset.distance) < parseFloat(b.dataset.distance) )
            return -1;
        if ( parseFloat(a.dataset.distance) > parseFloat(b.dataset.distance) )
            return 1;
        return 0;
    }
    compareName(a, b) {
        if ( a.dataset.name < b.dataset.name )
            return -1;
        if ( a.dataset.name > b.dataset.name )
            return 1;
        return 0;
    }

    fetchItem( reason, region = null ) {
        fetch(window.pv_search_ortho_ajax_object.ajaxurl + '?' + new URLSearchParams({
            action: 'get_item',
            'coordinates[lng]': this.geolng,
            'coordinates[lat]': this.geolat,
            'reason': reason,
            'region': region
        })).then((res) => res.json())
            .then( (data)=> {
                if (data.length !== 0) {
                    const itemContainer = document.querySelector('#listings');
                    const noResults     = itemContainer.querySelector('.no-results');
                    if ( noResults.classList.contains('show') ) {
                        noResults.classList.remove('show');
                    }
                    itemContainer.focus();
                    Array.from(data).forEach( post => {
                        let items = itemContainer.querySelectorAll('.items');
                        if ( items ) {
                            Array.from(items).forEach( item => {
                                let itemId = item.getAttribute('data-id');
                                if ( parseInt(post.id) === parseInt(itemId) ) {
                                    item.classList.add('selected');
                                    item.setAttribute('data-distance', post.distance);
                                }
                            });
                        }
                    });
                    let items = itemContainer.querySelectorAll('.items');
                    Array.from(items).forEach( item => {
                        if ( item.classList.contains('selected') ) {
                            item.style.display = 'flex';
                            item.classList.remove('selected');
                        }
                        else {
                            item.style.display = 'none';
                            item.removeAttribute('data-distance');
                        }
                    });
                    let indexes     = document.querySelectorAll("[data-distance]");
                    let arrItems    = Array.from(indexes);
                    let sortedItems = arrItems.sort(this.compareDistance);
                    sortedItems.forEach( item => itemContainer.appendChild(item));
                }
                else {
                    const itemContainer = document.querySelector('#listings');
                    let items           = itemContainer.querySelectorAll('.items');
                    const noResults     = itemContainer.querySelector('.no-results');
                    Array.from(items).forEach( item => {
                        if ( item.classList.contains('selected') ) {
                            item.style.display = 'flex';
                            item.classList.remove('selected');
                        }
                        else {
                            item.style.display = 'none';
                        }
                    });

                    noResults.classList.add('show');
                }
            });
    }
}